import SimpleGrid from "@vfuk/core-simple-grid";
import Image from "@vfuk/core-image";
import Heading from "@vfuk/core-heading";
import QuestionImage from "@img/Question.png";
import Spacing from "@vfuk/core-spacing";
import { CommercialCriteriaOrAccountNotConfiguredProps } from "./AllProps.types";

const CommercialCriteriaOrAccountNotConfigured = ({
  content,
}: CommercialCriteriaOrAccountNotConfiguredProps) => {
  return (
    <>
      <SimpleGrid justify="center">
        <Image
          alt="Question"
          lg={{
            src: QuestionImage,
            width: "280px",
            height: "280px",
          }}
        />
      </SimpleGrid>
      <SimpleGrid justify="center">
        <Spacing spacingLevel={{ bottom: 6 }} size-lg>
          <Heading size={2} weight={2} text={content} appearance="secondary" />
        </Spacing>
      </SimpleGrid>
    </>
  );
};
export default CommercialCriteriaOrAccountNotConfigured;
